export enum FileMimeType {
  Image,
  Video,
  Other,
}
